import { render, staticRenderFns } from "./wtEditAssetDetails.component.vue?vue&type=template&id=e2196e8e&"
import script from "./wtEditAssetDetails.component.vue?vue&type=script&lang=js&"
export * from "./wtEditAssetDetails.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports